import { Type } from "@angular/core";

export class PortableComponent {
  constructor(public component: Type<any>, public data: any) { }
}
